<template>
  <v-container px-0 py-0
    :class="{ configuration: menuToggle, casework: !menuToggle, 'white-menu-theme': whiteTheme }"><!-- Class 'white-menu-theme' needs added here when white theme on AccountConfigDetails is toggled and at the same time set menuColour to white -->
    <Loading :isLoading="loading">
      <!-- old toggle code <v-layout v-bind:class="{ 'toggle-panel-bg with-toggle pt-3 pb-0': isAdminMode, 'toggle-panel-bg pt-3': !isAdminMode }" wrap>
        <v-flex v-if="isAdminMode" xs12>
          <div :class="{'mobile menu-toggle': $vuetify.breakpoint.smAndDown, 'menu-toggle': $vuetify.breakpoint.mdAndUp}">
            <span v-bind:class="{ active: !menuToggle }">Casework</span>
            <v-switch id="menuToggle" v-model="menuToggle" style="display:inline-block"></v-switch>
            <span v-bind:class="{ active: menuToggle }">Configuration</span>
          </div>
        </v-flex>
      </v-layout>-->
      <div v-bar class="v-bar-wrapper w-100">
        <v-layout xs12 wrap fluid row class="aside-menus">
          <v-slide-y-transition hide-on-leave>
            <v-flex xs12 class="w-100" v-show="!menuToggle" id="slideMenuParent"
              v-bind:class="{ active: slideMenuActive }">

              <v-list dense expand class="pa-0 ma-0">
                <CaseTemplateSectionMenu v-for="menu in caseWorkMenu" :key="menu.section" :menu="menu"
                  :menu-group-open="menu.menuGroupOpen"></CaseTemplateSectionMenu>
              </v-list>
            </v-flex>
          </v-slide-y-transition>
          <v-slide-y-reverse-transition hide-on-leave>
            <v-flex xs12 class="w-100" v-show="menuToggle" id="slideMenuParentConfig"
              v-bind:class="{ active: slideMenuActiveConfig }">

              <v-list dense expand class="pa-0 ma-0">
                <CaseTemplateSectionMenu v-for="menu in configMenu" :key="menu.section" :menu="menu"
                  :menu-group-open="menu.menuGroupOpen"></CaseTemplateSectionMenu>
              </v-list>
            </v-flex>
          </v-slide-y-reverse-transition>
        </v-layout>
      </div>
    </Loading>
  </v-container>
</template>

<script>
import "material-design-icons-iconfont/dist/material-design-icons.css"
import Loading from "@/components/shared/Loading.vue"
import CaseTemplateSectionMenu from "@/components/navigation/CaseTemplateSectionMenu"
import Logo from "@/components/Logo.vue"
import { mapState } from "vuex"

export default {
  name: "MainMenu",
  props: {
    source: String,
    color: {
      type: String,
      default: ""
    }

  },
  components: { Logo, Loading, CaseTemplateSectionMenu },
  data: () => ({
    slideMenuActive: false,
    slideMenuActiveConfig: false,
    subSubItems: true,
    mini: false,
    right: null,
    loading: false,
    caseTypes: [],
    bucketMenu: [],
    adminMenu: []
  }),
  methods: {
    toggleMenu() {
      this.$store.dispatch("switchMenu", { opposite: true })
    }
  },
  computed: {
    menuToggle: {
      get() {
        return this.menuState !== "main"
      },
      set() {
        this.toggleMenu()
      }
    },
    ...mapState({
      menuColor: state => state.ui.menuColor,
      whiteTheme: state => state.ui.whiteTheme,
      isAdminMode: state => state.currentUser.isAccountAdmin,
      currentUser: state => state.currentUser,
      menuState: state => state.ui.menu,
      caseWorkMenu: state => state.ui.caseWorkMenu,
      noBookmarks: state => state.ui.caseWorkMenu && state.ui.caseWorkMenu[0].items && state.ui.caseWorkMenu[0].items[0] && state.ui.caseWorkMenu[0].items[0].childItems && state.ui.caseWorkMenu[0].items[0].childItems ? state.ui.caseWorkMenu[0].items[0].childItems.length : 0,
      configMenu: state => state.ui.configMenu
    })
  }
}
</script>

<style>
.sidebar-menu .v-list__tile__title {
  padding-left: 5px;
}

.mini .sidebar-menu .v-list__group__items,
.mini .sidebar-menu .v-list__group--active:after,
.mini .sidebar-menu .v-list__tile:hover>.v-btn.bookmark-button {
  display: none;
}

.mini .sidebar-menu .v-list__group .v-list__group__header:after {
  opacity: 0;
  visibility: hidden;
}

.mini .sidebar-menu:hover .v-list__group .v-list__group__header:after {
  opacity: 1;
  visibility: visible;
}

.mini .sidebar-menu:hover .v-list__group__items,
.mini .sidebar-menu:hover .v-list__group--active:after,
.mini .sidebar-menu:hover .v-list__group .v-list__group__header:after,
.mini .sidebar-menu:hover .v-list__tile:hover>.v-btn.bookmark-button {
  display: initial;
}

.mini .sidebar-menu:hover {
  width: 300px !important;
}

.v-navigation-drawer .v-list__tile__action,
.v-navigation-drawer .v-list__tile__avatar {
  -webkit-box-pack: center !important;
  -ms-flex-pack: center !important;
  justify-content: center !important;
}

.mini .v-navigation-drawer--mini-variant .v-divider {
  display: block !important;
}

.v-list__tile--active.primary--text {
  color: #09a1b0 !important;
  font-weight: bold;
}

.theme--dark.v-navigation-drawer {
  background-color: rgb(29, 48, 62) !important;
}

/* Light-theme class on the drawer was recolouring labels to the drawer bg. */
.sidebar-menu.theme--dark.v-navigation-drawer .v-list,
.sidebar-menu.theme--dark.v-navigation-drawer .v-list a,
.sidebar-menu.theme--dark.v-navigation-drawer .v-list__tile__title,
.sidebar-menu.theme--dark.v-navigation-drawer .v-icon,
.sidebar-menu.theme--dark.v-navigation-drawer .v-list__group__header:after {
  color: #fff !important;
}

.sidebar-menu.theme--dark.v-navigation-drawer .v-list__tile--active.primary--text,
.sidebar-menu.theme--dark.v-navigation-drawer .v-list__tile--active.primary--text .v-list__tile__title {
  color: #09a1b0 !important;
}

.theme--dark.v-navigation-drawer .white-menu-theme,
.theme--dark.v-navigation-drawer.configuration .white-menu-theme,
.theme--dark.v-navigation-drawer.casework .white-menu-theme {
  background: white !important;
  transition: all 0s;
}

.white-menu-theme .menu-back-link--text,
.white-menu-theme .menu-back-link--icon,
.white-menu-theme .menu-toggle span,
.white-menu-theme .sub-item-group-custom-style .v-list__tile__title:after,
.white-menu-theme .theme--dark.v-list,
.white-menu-theme .theme--dark.v-list a,
.white-menu-theme .v-list__group__header:after {
  color: #1d303e !important;
  -webkit-transition: all 0s;
  transition: all 0s;
}

.white-menu-theme .menu-back-link .theme--dark.v-btn {
  background: #1d303e !important;
  transition: all 0.2s;
}

.white-menu-theme .menu-back-link .v-icon {
  color: white !important;
  transition: all 0.2s;
}

.white-menu-theme .toggle-panel-bg {
  background: none;
  transition: all 0.2s;
  border-bottom: 1px solid rgba(29, 48, 62, 0.2);
}

.white-menu-theme .sub-item-group-custom-style .v-list__group__items .v-list__tile__title {
  border-left-color: rgba(29, 48, 62, 0.2) !important;
  transition: all 0.2s;
}

.theme--dark.v-list .v-list__group--active:before {
  display: none;
}

.v-navigation-drawer .white-menu-theme .theme--dark.v-divider {
  border-color: rgba(29, 48, 62, 0.2) !important;
  transition: all 0.2s;
}

.white-menu-theme .theme--dark.v-list .v-list__group--active:after {
  background: rgba(29, 48, 62, 0.2);
  transition: all 0.2s;
}

.white-menu-theme .v-list__tile:hover>.v-btn.bookmark-button .theme--dark.v-icon {
  color: rgba(29, 48, 62, 0.4) !important;
  transition: all 0.2s;
}

.white-menu-theme .v-list__tile:hover>.v-btn.bookmark-button.bookmarked .theme--dark.v-icon {
  color: rgba(29, 48, 62, 1) !important;
  transition: all 0.2s;
}

.white-menu-theme .theme--dark.v-btn.bookmark-button {
  color: rgba(29, 48, 62, 1) !important;
  transition: all 0.2s;
}

.sidebar-menu {
  webkit-box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12) !important;
  z-index: 60 !important;
}

.menu-toggle {
  text-align: center;
  margin: 15px 0 0 0;
  padding: 0 24px 0 24px;
}

.menu-toggle.mobile {
  margin: 57px 0 0 0;
}

.menu-toggle .v-input--selection-controls {
  margin: 0;
  padding: 0;
}

.menu-toggle .v-input--selection-controls__input {
  margin: 0 12px;
}

.menu-toggle span {
  color: white;
  opacity: 0.5;
  display: inline-block;
  vertical-align: top;
}

.menu-toggle span.active {
  opacity: 1;
}

.menu-toggle .theme--dark.v-input--switch__thumb {
  color: #ffffff;
}

.menu-toggle .v-input--switch__track {
  opacity: 0.2 !important;
  background: white !important;
}

.menu-toggle .accent--text {
  color: #ffffff !important;
}

.aside-menus {
  overflow: auto;
}

.v-bar-wrapper {
  margin: 50px 0 0 0;
  height: calc(100vh - 50px);
}

.toggle-panel-bg {
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: -moz-linear-gradient(top,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.25) 100%);
  /* FF3.6-15 */
  background: -webkit-linear-gradient(top,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.25) 100%);
  /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.25) 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#33000000', endColorstr='#73000000', GradientType=0);
  /* IE6-9 */

  height: 70px;
}

.toggle-panel-bg.with-toggle {
  height: 110px;
}

.casework {
  min-height: 100vh;
}

.configuration {
  background: #3a3a3a;
  /* Old browsers */
  background: -moz-linear-gradient(top, #3a3a3a 0%,
      #262626 100%);
  /* FF3.6-15 */
  background: -webkit-linear-gradient(top,
      #3a3a3a 0%,
      #262626 100%);
  /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to bottom,
      #3a3a3a 0%,
      #262626 100%);
  /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#3a3a3a', endColorstr='#262626', GradientType=0);
  /* IE6-9 */
  min-height: 100vh;
}

.sidebar-menu.v-navigation-drawer .v-list__tile__action {
  min-width: 26px;
}

.sidebar-menu .v-list__group__header .v-list__group__header__append-icon,
.sidebar-menu .v-list__group__header .v-list__group__header__prepend-icon {
  display: none;
}

.sidebar-menu .v-list__group__header:after {
  content: "\e5df";
  display: block;
  position: absolute;
  top: 8px;
  font-size: 25px;
  right: 12px;
  transition: all 0.3s ease;
  direction: ltr;
  display: inline-block;
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  -webkit-font-feature-settings: "liga";
  font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
  color: white;
  transition: all 0.2s;
  opacity: 1;
  visibility: visible;
}

.sidebar-menu .no-group-styling .v-list__group__header:after {
  display: none !important;
}

.sidebar-menu .v-list__group__header.v-list__group__header--active:after {
  transform: rotate(90deg);
}

.sidebar-menu.v-navigation-drawer .v-list__group__items--no-action .v-list__tile {
  padding-left: 55px;
  padding-right: 45px;
}

.sidebar-menu.v-navigation-drawer .v-list--dense .v-list__tile .v-icon {
  font-size: 20px;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style {
  padding-left: 0px;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .v-list__tile {
  padding-left: 42px;
  padding-right: 45px;
}

.sidebar-menu.v-navigation-drawer .v-list__group__items .no-group-styling .v-list__tile {
  padding-left: 42px;
  padding-right: 45px;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style.v-list__group--active {
  margin: 0 0 0px 0;
}

.sidebar-menu.v-navigation-drawer .sub-sub-item-group-custom-style:before,
.sidebar-menu.v-navigation-drawer .sub-sub-item-group-custom-style:after {
  display: none !important;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .v-list__group__items .v-list__tile__title {
  padding-left: 18px;
  position: relative;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .sub-sub-item:first-of-type .v-list__tile__title:before {
  content: '\e5da';
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  top: 7px;
  padding-left: 0;
  left: 0px;
  font-family: 'Material Icons';
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .v-list__group__items .no-group-styling .v-list__tile__title {
  width: 100%;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .v-list__group__header__append-icon {
  display: none;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .v-list__tile__title {
  height: 37px;
  position: relative;
  width: auto;
  padding: 8px 20px 0 0;
}

.sidebar-menu.v-navigation-drawer .fourth-level .v-list__tile__title {
  padding-left: 40px !important;
}

.bookmark-button {
  display: none !important;
  position: absolute !important;
  top: -5px;
  right: -2px
}

.bookmark-button.bookmarked {
  display: block !important;
}

.v-list__tile:hover>.v-btn.bookmark-button.bookmarked .theme--dark.v-icon {
  color: white !important;
}

.v-list__tile:hover>.v-btn.bookmark-button {
  display: block !important;
}

.v-list__tile:hover>.v-btn.bookmark-button .theme--dark.v-icon {
  color: rgba(255, 255, 255, 0.4) !important;
}

.sidebar-menu .sub-item-group-custom-style .v-list__group__header:after {
  display: none !important;
}

.sidebar-menu .sub-item-group-custom-style .v-list__tile__title:after {
  content: "\e5df";
  display: block;
  position: absolute;
  top: 8px;
  font-size: 25px;
  right: -7px;
  transition: all 0.3s ease;
  direction: ltr;
  display: inline-block;
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  line-height: 1;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  -webkit-font-feature-settings: "liga";
  font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
  color: white;
}

.sidebar-menu .sub-item-group-custom-style .v-list__group__header--active .v-list__tile__title:after {
  transform: rotate(90deg);

}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .v-list__tile:hover .v-list__tile__title:after {
  transition: all 0.2s;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .v-list__group__header--active .v-list__tile__title:after {
  transition: all 0.2s;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style:before,
.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style:after {
  display: none;
}

.sidebar-menu.v-navigation-drawer .sub-item-group-custom-style .no-group-styling .v-list__tile__title:after {
  display: none !important;
}

.sidebar-menu.v-navigation-drawer .no-child .v-list__group__header:after {
  display: none !important;
}

.sidebar-menu.v-navigation-drawer .sub-sub-item-custom-style .v-list__tile--link {
  height: 38px;
}

.sidebar-menu.v-navigation-drawer .sub-sub-item-custom-style .v-list__tile__title:after {
  display: none;
}

#slideMenu {
  transform: translateX(-100%);
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  width: 100%;
}

#slideMenu.active {
  transform: translateX(0%);
  transition: all 0.3s ease;
}

#slideMenuParent {
  display: block;
  transform: translateX(0%);
  transition: all 0.3s ease;
}

#slideMenuParent.active {
  transform: translateX(-100%);
  transition: all 0.3s ease;
}

#slideMenuConfig {
  transform: translateX(-100%);
  transition: all 0.3s ease;
  position: absolute;
  top: 0;
  width: 100%;
}

#slideMenuConfig.active {
  transform: translateX(0%);
  transition: all 0.3s ease;
}

#slideMenuParentConfig {
  display: block;
  transform: translateX(0%);
  transition: all 0.3s ease;
}

#slideMenuParentConfig.active {
  transform: translateX(-100%);
  transition: all 0.3s ease;
}

.menu-back-link--text,
.menu-back-link--icon {
  color: white;
  font-weight: 500;
  cursor: pointer;
}

.menu-back-link--text:hover {
  opacity: 0.54;
}

.sidebar-menu .theme--dark.v-list {
  transition: all 0s linear !important;
}

/* Scrollbar Styles */
.vb>.vb-dragger {
  z-index: 5;
  width: 12px;
  right: 0;
}

.vb>.vb-dragger>.vb-dragger-styler {
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -webkit-transform: rotate3d(0, 0, 0, 0);
  transform: rotate3d(0, 0, 0, 0);
  -webkit-transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out;
  transition: background-color 100ms ease-out, margin 100ms ease-out, height 100ms ease-out;
  background-color: rgba(0, 0, 0, .0);
  margin: 5px 5px 5px 0;
  border-radius: 15px;
  height: calc(100% - 10px);
  display: block;
}

.vb:hover>.vb-dragger>.vb-dragger-styler {
  background-color: rgba(0, 0, 0, .15);
}

.white-menu-theme .vb:hover>.vb-dragger>.vb-dragger-styler {
  background-color: rgba(29, 48, 62, .05);
}

.vb.vb-scrolling-phantom>.vb-dragger>.vb-dragger-styler {
  background-color: rgba(0, 0, 0, .3);
}

.vb>.vb-dragger:hover>.vb-dragger-styler {
  background-color: rgba(0, 0, 0, .3);
  margin: 0;
  height: 100%;
  border-radius: 0;
}

.vb.vb-dragging>.vb-dragger>.vb-dragger-styler {
  background-color: rgba(0, 0, 0, .22);
  margin: 0;
  height: 100%;
}

.vb.vb-dragging-phantom>.vb-dragger>.vb-dragger-styler {
  background-color: rgba(0, 0, 0, .6);
}

.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {
  height: 37px !important;
}

.fixed-toolbar {
  -webkit-box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px 0px rgba(0, 0, 0, 0) !important;
}

.fixed-toolbar .v-toolbar__content {
  padding-right: 4px;
}
</style>
